module.exports = __webpack_public_path__ + "img/menu-config.750593c4.png";